import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiLink, EuiPageTemplate, EuiPageHeader, EuiCard } from '@elastic/eui';
import { Header } from './components/header';
import { Footer } from './components/footer';
import patent1page1 from '../documents/patent1page1.jpg'
import patent2image1 from '../documents/patent2image1.jpeg'
import discussion1page1 from '../documents/discussion1page1.jpg'
import discussion2page1 from '../documents/discussion2page1.jpg'
import discussion3page1 from '../documents/discussion3page1.jpg'
import journal1image1 from '../documents/journal1image1.png'
import journal2image1 from '../documents/journal2image1.png'
import project1image3 from '../documents/project1image3.jpg'
class Research extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            patent2objective: "Deployment of Hybrid GAN model for generating concrete mix database",
            patent2Key: ['Industry 4.0 C (C- Civil, Concrete, Construction)', 'Hybrid Generative Adversarial Network', 'Data augmentation and generation of concrete mix', 'Hybrid GAN for regression problem', '5+ Patent claims', 'Mobile Application is user defined'],
            patent2Value: ['Innovation','Concept Development','Inter-disciplinary Engineering']
        }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                    <EuiSpacer />
                    <EuiText><h2><font face='Segoe UI'><b>Patents</b></font></h2></EuiText>
                    <EuiSpacer size='m' />
                    <EuiCard
                    image={
                      <div>
                      <img //style={{width: '100%',height: '35vw'}}
                            src={patent1page1}
                            alt="Nature"
                            href="/about"
                          />
                    </div>
                      }
                    textAlign="left"
                    title={<EuiText><b>1. Universal Hybrid Model to Predict Mix Based Compressive Strength and
                    Allied Mechanical Properties of Concrete (Application Number – <EuiLink href="https://drive.google.com/file/d/1bjLb9SaMhtI2vUEBMftJDQNF9Pj25LOq/view" target="_blank">202121022677</EuiLink>, Journal Number – 26/2021, Journal Date – 25/06/2021)</b> </EuiText>}
                    titleSize="xs"
                    description={<EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>Mentor :- Dr. Hemant Dhonde</EuiFlexItem>
                    <EuiFlexItem grow={false}>August 2020 – Present</EuiFlexItem>
                  </EuiFlexGroup>}>
                        <EuiLink href={"/research/patent1"}>Read More</EuiLink>
                    </EuiCard>
                    <EuiSpacer size='xl' />
                    <EuiCard
                    image={
                        <div>
                          <img //style={{width: '100%',height: '20vw'}}
                            src={patent2image1}
                            alt="Nature"
                            href="/about"
                          />
                        </div>
                      }
                    textAlign="left"
                    title={<EuiText><b>2.	Concrete GAN: Hybrid GAN Approach for Data Augmentation and Generation</b></EuiText>}
                    titleSize="xs"
                    description={<EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>Mentor :- Dr. Hemant Dhonde</EuiFlexItem>
                    <EuiFlexItem grow={false}>May 2021 – Present</EuiFlexItem>
                  </EuiFlexGroup>}>
                        <EuiLink href={"/research/patent2"}>Read More</EuiLink>
                    </EuiCard>
                    <EuiSpacer size='xl' />

                    <EuiText><h2><font face='Segoe UI'><b>Discussions and Closures</b></font></h2></EuiText>
                    <EuiSpacer size='m' />
                    <EuiCard
                    image={
                      <div>
                      <img //style={{width: '100%',height: '35vw'}}
                            src={discussion1page1}
                            alt="Nature"
                            href="/about"
                          />
                    </div>
                      }
                    textAlign="left"
                    title={<EuiText><b>1.	Discussion & Closure of “Early-Age Behavior of Internally Cured Concrete Bridge Deck under Environmental Loading” by Waleed K. Hamid, Eric P. Steinberg, Ali A. Semendary, Issam Khoury, and Kenneth Walsh <EuiLink href="https://drive.google.com/file/d/1anpbAUce-1kyBUp7leCYmYuFMEfKOD1l/view" target="_blank">Link</EuiLink></b></EuiText>}
                    titleSize="xs"
                    description={<EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>Status: Published </EuiFlexItem>
                    <EuiFlexItem grow={false}>July – September 2020</EuiFlexItem>
                  </EuiFlexGroup>}>
                        <EuiLink href={"/research/discussion1"}>Read More</EuiLink>
                    </EuiCard>
                    <EuiSpacer size='xl' />
                    <EuiCard
                    image={
                      <div>
                      <img //style={{width: '100%',height: '35vw'}}
                            src={discussion2page1}
                            alt="Nature"
                            href="/about"
                          />
                    </div>
                      }
                    textAlign="left"
                    title={<EuiText><b>2.	Discussion of “Thermally Induced Behavior of Paired Internally Cured Concrete and Conventional Concrete Decks in Composite Bridges” by Waleed K. Hamid, Eric P.Steinberg, Issam Khoury, Ali A. Semendary, and Kenneth Walsh <EuiLink href="https://drive.google.com/file/d/1RGiXntCiOTmZkAqzMs3O3bllRVZIKEal/view" target="_blank">Link</EuiLink></b></EuiText>}
                    titleSize="xs"
                    description={<EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>Status: Forthcoming </EuiFlexItem>
                    <EuiFlexItem grow={false}>May 2021 – Present</EuiFlexItem>
                  </EuiFlexGroup>}>
                        <EuiLink href={"/research/discussion2"}>Read More</EuiLink>
                    </EuiCard>
                    <EuiSpacer size='xl' />
                    <EuiCard
                    image={
                      <div>
                      <img //style={{width: '100%',height: '35vw'}}
                            src={discussion3page1}
                            alt="Nature"
                            href="/about"
                          />
                    </div>
                      }
                    textAlign="left"
                    title={<EuiText><b>3.	Discussion of “Improvement in Estimating Durations for Building Projects Using Artificial Neural Network and Sensitivity Analysis” by Su-Ling Fan, I-Cheng Yeh and Wei-Sheng</b></EuiText>}
                    titleSize="xs"
                    description={<EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>Status: Under Review</EuiFlexItem>
                    <EuiFlexItem grow={false}>May 2021 – Present</EuiFlexItem>
                  </EuiFlexGroup>}>
                        <EuiLink href={"/research/discussion3"}>Read More</EuiLink>
                    </EuiCard>
                    <EuiSpacer size='xl' />

                    <EuiText><h2><font face='Segoe UI'><b>Journal Papers</b></font></h2></EuiText>
                    <EuiSpacer size='m' />
                    <EuiCard
                    image={
                        <div>
                          <img style={{width: '100%',height: '25vw'}}
                            src={journal1image1}
                            alt="Nature"
                            href="/about"
                          />
                        </div>
                      }
                    textAlign="left"
                    title={<EuiText><b>1.	Prediction of Mix Based Compressive Strength of Concrete using Modified Dimensional Analysis</b> </EuiText>}
                    titleSize="xs"
                    description={<EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>Mentor :- Dr. Hemant Dhonde, Dr. Shilpa Patil</EuiFlexItem>
                    <EuiFlexItem grow={false}>May 2020 – Present</EuiFlexItem>
                  </EuiFlexGroup>}>
                        <EuiLink href={"/research/journal1"}>Read More</EuiLink>
                    </EuiCard>
                    <EuiSpacer size='xl' />
                    <EuiCard
                    image={
                        <div>
                          <img style={{width: '100%',height: '30vw'}}
                            src={journal2image1}
                            alt="Nature"
                            href="/about"
                          />
                        </div>
                      }
                    textAlign="left"
                    title={<EuiText><b>2.	Mathematical Models for estimation of percentage mass loss using optimum Acoustic Emission parameters</b> </EuiText>}
                    titleSize="xs"
                    description={<EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>Mentor :- Dr. Shilpa Patil</EuiFlexItem>
                    <EuiFlexItem grow={false}>May 2021 – Present</EuiFlexItem>
                  </EuiFlexGroup>}>
                        <EuiLink href={"/research/journal2"}>Read More</EuiLink>
                    </EuiCard>
                    <EuiSpacer size='xl' /> 

                    <EuiText><h2><font face='Segoe UI'><b>University Sponsored Projects</b></font></h2></EuiText>
                    <EuiSpacer size='m' />
                    <EuiCard
                    image={
                        <div>
                          <img //style={{width: '100%',height: '35vw'}}
                            src={project1image3}
                            alt="Nature"
                            href="/about"
                          />
                        </div>
                      }
                    textAlign="left"
                    title={<EuiText><b>1.	Spinning - Rebar Tie tool</b> </EuiText>}
                    titleSize="xs"
                    description={<EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>Advisor - PI: - Prof. Dr. Archana Tanawade, Co-PI: - Hemant Dhonde</EuiFlexItem>
                    <EuiFlexItem grow={false}>February 2020- March 2021</EuiFlexItem>
                  </EuiFlexGroup>}>
                        <EuiLink href={"/research/project1"}>Read More</EuiLink>
                    </EuiCard>
                    <EuiSpacer size='xl' />
                    
                </EuiFlexItem>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Research }